import React from 'react';
import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Info } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { PartialLabelData } from '../../../api';
import { useLanguage } from '../../../utils/GeneralUtils';

interface PracticalInfoSectionProps {
  items: PartialLabelData[];
}

export const PracticalInfoSection = ({ items }: PracticalInfoSectionProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const language = useLanguage();

  const validItems = items.filter((item) => item[language]);

  if (validItems.length === 0) {
    return null;
  }

  return (
    <Box sx={{ marginBottom: isSmallScreen ? 4 : 5 }}>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          marginBottom: 2,
        }}>
        {t('experiencePage.practicalInfo')}
      </Typography>

      <Grid container flexDirection="column" gap={1.5}>
        {validItems.map((item, index) => (
          <Grid key={index} container alignItems="flex-start" gap={1.5}>
            <Info
              sx={{
                fontSize: 22,
                color: 'primary.main',
                marginTop: 0.25,
              }}
            />
            <Typography
              variant="body1"
              sx={{
                flex: 1,
                lineHeight: 1.5,
              }}
              dangerouslySetInnerHTML={{ __html: item[language] || '' }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
